import './Modal.css';
export default {
    "dialog": "Modal_dialog__1zirs",
    "oneChild": "Modal_oneChild__1zirs",
    "container": "Modal_container__1zirs",
    "header": "Modal_header__1zirs",
    "content": "Modal_content__1zirs",
    "closeButton": "Modal_closeButton__1zirs",
    "modalOpen": "Modal_modalOpen__1zirs",
    "drawerUp": "Modal_drawerUp__1zirs",
    "drawerUpHalf": "Modal_drawerUpHalf__1zirs",
    "drawerDownHalf": "Modal_drawerDownHalf__1zirs",
    "drawerDown": "Modal_drawerDown__1zirs"
};
